module.exports = __webpack_public_path__ + "hbomaxar-static/media/back-caret.a16536cd.svg";